let _ppi: number = 0;
const cmsInInch: number = 2.54;

export class Converter {
    public static ppi(): number {
        _ppi =
            _ppi ||
            (function () {
                const div = document.createElement('div');
                div.style.visibility = 'hidden';
                div.style.width = '1in';
                div.style.padding = '0';
                document.body.appendChild(div);
                const pixelsByCm = div.offsetWidth / cmsInInch;
                document.body.removeChild(div);
                return pixelsByCm;
            })();
        return _ppi;
    }

    public static pixels2cm(pixels: number): number {
        return pixels / Converter.ppi();
    }

    public static cm2pixels(cm: number): number {
        return cm * Converter.ppi();
    }

    public static cm2inch(cm: number): number {
        return cm / cmsInInch;
    }

    public static inch2cm(inch: number): number {
        return inch * cmsInInch;
    }
}
